/* ExamFlow Boot Camp — small interactions: light/dark preview toggles and the phone buy bar. */
(function () {
  'use strict';

  // Light / dark (and Dawn / Day) screenshot toggles
  function initToggles(root) {
    root.querySelectorAll('[data-ef-themes]').forEach(function (box) {
      if (box.dataset.efReady) return;
      box.dataset.efReady = '1';
      var buttons = box.querySelectorAll('[data-ef-theme-btn]');
      var panes = box.querySelectorAll('[data-ef-theme-pane]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var which = btn.getAttribute('data-ef-theme-btn');
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          panes.forEach(function (p) { p.hidden = p.getAttribute('data-ef-theme-pane') !== which; });
        });
      });
    });
  }

  // Sticky buy bar on phones: copies the highlighted pricing card of this page,
  // appears after the hero, and steps aside over the pricing cards and the planner
  var stickyBound = false;
  function initSticky() {
    var bar = document.querySelector('[data-ef-sticky]');
    if (!bar) return;
    var offer = document.querySelector('[data-ef-main-offer]');
    if (!offer) { bar.hidden = true; return; }
    var name = bar.querySelector('[data-ef-sticky-name]');
    var price = bar.querySelector('[data-ef-sticky-price]');
    var link = bar.querySelector('[data-ef-sticky-link]');
    var offerPrice = offer.querySelector('[data-ef-offer-price]');
    var offerLink = offer.querySelector('[data-ef-offer-link]');
    if (name) name.textContent = offer.getAttribute('data-name') || '';
    if (price && offerPrice) price.innerHTML = offerPrice.innerHTML;
    if (link && offerLink) link.setAttribute('href', offerLink.getAttribute('href'));
    bar.hidden = false;

    var hero = document.querySelector('.ef-hero');
    var avoid = Array.prototype.slice.call(document.querySelectorAll('#pricing, [data-ef-planner]'));
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      var afterHero = hero ? y > hero.offsetTop + hero.offsetHeight * 0.7 : y > 400;
      var inTheWay = avoid.some(function (el) {
        var r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });
      bar.classList.toggle('is-visible', afterHero && !inTheWay);
    }
    if (!stickyBound) {
      stickyBound = true;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
    }
    update();
  }

  // Home page: "Tell me when it's out" on an exam card picks that exam in the signup form
  function initWaitlist(root) {
    var select = document.querySelector('[data-ef-waitlist-select]');
    if (!select) return;
    root.querySelectorAll('[data-ef-waitlist]').forEach(function (btn) {
      if (btn.dataset.efReady) return;
      btn.dataset.efReady = '1';
      btn.addEventListener('click', function () {
        var want = (btn.getAttribute('data-ef-waitlist') || '').toLowerCase();
        Array.prototype.forEach.call(select.options, function (o) {
          if (o.textContent.trim().toLowerCase() === want) select.value = o.value;
        });
        var email = document.getElementById('ef-waitlist-email');
        if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, 400);
      });
    });
  }

  // Mission Planner: honest maths from the visitor's own date and numbers. Nothing is stored.
  function initPlanner(root) {
    root.querySelectorAll('[data-ef-planner]').forEach(function (box) {
      if (box.dataset.efReady) return;
      box.dataset.efReady = '1';
      var rest = parseInt(box.getAttribute('data-rest'), 10); if (isNaN(rest)) rest = 1;
      var perWeekAnswers = parseInt(box.getAttribute('data-answers'), 10) || 5;
      var form = box.querySelector('[data-ef-planner-form]');
      var $ = function (sel) { return box.querySelector(sel); };
      var states = box.querySelectorAll('[data-ef-state]');
      var dayIn = $('[data-ef-in="day"]');
      var monthIn = $('[data-ef-in="month"]');
      var yearIn = $('[data-ef-in="year"]');
      var hoursIn = $('[data-ef-in="hours"]');
      var kits = {
        sheets: box.getAttribute('data-kit-sheets'),
        lab: box.getAttribute('data-kit-lab'),
        complete: box.getAttribute('data-kit-complete'),
        all: box.getAttribute('data-kit-all')
      };
      var fmt = function (n) { return Math.round(n).toLocaleString('en-IN'); };

      function show(name) { states.forEach(function (s) { s.hidden = s.getAttribute('data-ef-state') !== name; }); }

      function update() {
        var hours = parseInt(hoursIn.value, 10) || 1;
        $('[data-ef-out="hours-in"]').textContent = hours;
        var dd = parseInt(dayIn.value, 10), mm = parseInt(monthIn.value, 10), yy = parseInt(yearIn.value, 10);
        if (!dd || !mm || !yy) { show('empty'); return; }
        var lastDay = new Date(yy, mm, 0).getDate();
        if (dd > lastDay) { dd = lastDay; dayIn.value = String(lastDay); }

        var today = new Date(); today.setHours(0, 0, 0, 0);
        var exam = new Date(yy, mm - 1, dd);
        var days = Math.round((exam - today) / 86400000);
        if (!(days > 14)) { show('past'); return; }

        var weeks = days / 7;
        var studyDays = days * (7 - rest) / 7;
        var answers = Math.floor(weeks * perWeekAnswers);

        $('[data-ef-out="days"]').textContent = fmt(days);
        $('[data-ef-out="answers"]').textContent = fmt(answers);
        $('[data-ef-out="hours"]').textContent = fmt(studyDays * hours);

        var pace;
        if (hours >= 9) pace = 'That\'s a big daily target. The hard part is hitting it on day 80, not day 1. Logging every night is how you\'ll know.';
        else if (hours >= 5) pace = 'A realistic, steady target. Over ' + fmt(weeks) + ' weeks, the days you show up will matter more than any single big day.';
        else pace = 'Lighter days are fine. A 2-hour day logged beats a blank day, and it all adds up.';
        $('[data-ef-out="pace"]').textContent = pace;

        var weeksLeft = Math.floor(weeks);
        $('[data-ef-out="wait"]').textContent = 'One of your ' + weeksLeft + ' remaining weeks is gone: about ' + fmt((7 - rest) * hours) + ' study hours and ' + perWeekAnswers + ' Mains answers you could have written and tracked.';

        var hard = form.querySelector('input[name="hard"]:checked');
        $('[data-ef-out="kit"]').textContent = kits[hard ? hard.value : 'all'] || '';
        show('result');
      }

      form.addEventListener('submit', function (e) { e.preventDefault(); });
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      update();
    });
  }

  // Launch bar: hide it on the visitor's device after the real end date, even if a cached page is shown
  function initLaunch() {
    var bar = document.querySelector('[data-ef-launch]');
    if (!bar) return;
    var end = bar.getAttribute('data-end');
    if (!end) return;
    var endDay = new Date(end + 'T23:59:59');
    if (!isNaN(endDay) && new Date() > endDay) bar.hidden = true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initToggles(document);
    initSticky();
    initPlanner(document);
    initLaunch();
    initWaitlist(document);
  });

  // Keep working inside the theme editor when sections are added or changed
  document.addEventListener('shopify:section:load', function (e) { initToggles(e.target); initSticky(); initPlanner(e.target); initLaunch(); initWaitlist(e.target); });
})();
